import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { radiusHelper } from '@property.com.au/ui-kit';

interface AgencyLogo {
  alt: string;
  jpgUri: string;
  webpUri: string;
}

export interface PropertyTimelineAgencyProps {
  brandColour: string;
  logo?: AgencyLogo | null;
}

interface AgencyDetailsProps {
  $brandColour: string;
}

const StyledAgencyImage = styled.img`
  display: block;
`;

export const AgencyDetails = styled.div<AgencyDetailsProps>`
  width: 192px;
  height: 37px;
  background: ${({ $brandColour }) => $brandColour};
  border-radius: ${radiusHelper('medium')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PropertyTimelineAgency: FunctionComponent<PropertyTimelineAgencyProps> = ({
  brandColour,
  logo,
}) => {
  return (
    <AgencyDetails $brandColour={brandColour}>
      {logo ? (
        <picture>
          <source srcSet={logo.webpUri} type="image/webp" />
          <StyledAgencyImage alt={logo.alt} src={logo.jpgUri} />
        </picture>
      ) : null}
    </AgencyDetails>
  );
};
